import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/@mui/utils/getDisplayName/index.js';

var require$$6 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$6 as default };
